/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_No_EventsInputs */



/**
* | output |
* | --- |
* | "The selected Event Group has no events." |
*
* @param {Offline_Sync_No_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_no_events = /** @type {((inputs?: Offline_Sync_No_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_No_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le groupe d'événements sélectionné ne contient aucun événement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die ausgewählte Ereignisgruppe enthält keine Ereignisse.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il gruppo eventi selezionato non contiene eventi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбранная группа событий не содержит событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El grupo de eventos seleccionado no tiene eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所选事件组没有事件。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したイベントグループにはイベントがありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित इवेंट समूह में कोई इवेंट नहीं हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O grupo de eventos selecionado não tem eventos.")
	return /** @type {LocalizedString} */ ("The selected Event Group has no events.")
});